module.exports = __webpack_public_path__ + "img/2_2-finanziario-torre-1.a2640da3.png";